var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15799_6333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87199 15.7472C12.2196 15.7472 15.7441 12.2227 15.7441 7.87504C15.7441 3.52735 12.2197 0.00292969 7.87199 0.00292969C3.52431 0.00292969 -0.000151634 3.52739 -0.000151634 7.87508C-0.000151634 12.2228 3.52435 15.7472 7.87199 15.7472ZM7.87199 2.25213C10.9775 2.25213 13.4949 4.76959 13.4949 7.87508C13.4949 10.9806 10.9775 13.498 7.87199 13.498C4.76651 13.498 2.24904 10.9806 2.24904 7.87508C2.24904 4.76959 4.76655 2.25213 7.87199 2.25213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8689 17.9966C17.1678 17.9984 17.4551 17.881 17.6673 17.6705C18.1083 17.2331 18.1112 16.5211 17.6739 16.0801C17.6717 16.0779 17.6695 16.0758 17.6673 16.0736L13.4389 11.8451C12.9824 11.4041 12.2548 11.4167 11.8138 11.8732C11.3728 12.3297 11.3854 13.0573 11.8419 13.4983L16.0704 17.6705C16.2827 17.881 16.57 17.9984 16.8689 17.9966Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15799_6333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.721e779846ffb7e247206c5907822584.svg";
export { ForwardRef as ReactComponent };